/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Show_Vehicle_Paths_DisabledInputs */

const fr_settings_show_vehicle_paths_disabled = /** @type {(inputs: Settings_Show_Vehicle_Paths_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non`)
};

const en_settings_show_vehicle_paths_disabled = /** @type {(inputs: Settings_Show_Vehicle_Paths_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

/**
* | output |
* | --- |
* | "No" |
*
* @param {Settings_Show_Vehicle_Paths_DisabledInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_show_vehicle_paths_disabled = /** @type {((inputs?: Settings_Show_Vehicle_Paths_DisabledInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Show_Vehicle_Paths_DisabledInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_settings_show_vehicle_paths_disabled(inputs)
	return en_settings_show_vehicle_paths_disabled(inputs)
});